export const formatLatencySeconds = (latencyMs: number) => `${(latencyMs / 1000).toFixed(1)} s`
